// src/context/AuthContext.tsx
import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

interface User {
  srNo: number;
  userName: string;
  userRole: number;
  emailId: string;
  mobileNo: string;
}

interface AuthContextType {
  user: User | null;
  login: (userData: User) => void;
  logout: () => void;
  isLoading: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [user, setUserState] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  useEffect(() => {
    // LocalStorage se naya data get karo
    const storedData = localStorage.getItem('userData');
    if (storedData) {
      setUserState(JSON.parse(storedData));
    }
    setIsLoading(false);
  }, []);

  const login = (userData: User) => {
    setUserState(userData);
    localStorage.setItem('userData', JSON.stringify(userData)); // Ek hi string me sab save kar diya
  };

  const logout = () => {
    setUserState(null);
    localStorage.removeItem('userData');
    localStorage.removeItem('userToken');
    navigate('/');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) throw new Error('useAuth must be used within an AuthProvider');
  return context;
};